export default {
  title: 'Detalhes de envio',
  buttons: {
    save: 'Guardar',
  },
};
